import React from "react";
import { Form } from "antd";
import {
  InputField,
  DatePickerField,
  SelectInput,
  AntdButton,
} from "../../../blueplanitUtils/InputField";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { getOptionsByPath } from "../../../utilsdata.js";
import {ASSET_CATEGORY,ADD_ASSET, ADD_EDIT_EMPLOYEE, EMPLOYEE_DEPARTMENT } from "../../../Dropdownmanager.jsx";
import { useSelector } from "react-redux";

const ListAssetsFilters = ({
  filterForm,
  handleSearch,
  handleClear,
  options,
  assignToUsers,
  setShowFilters,
}) => {
  const getAssignToUsers = (users) =>
    users.map((user, index) => ({
      key: index,
      value: `${user.firstname} ${user.lastname}`,
      label: `${user.firstname} ${user.lastname}`,
    }));
  const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);


  return (
    <div
      style={{
        position: "fixed",
        top: 64,
        left: 0,
        height: "calc(100vh - 64px)",
        width: "250px",
        overflowY: "auto",
        backgroundColor: "#f5f5f5",
        borderRight: "1px solid #ccc",
        padding: 16,
        zIndex: 1000,
      }}
    >
      <div style={{ position: "relative" }}>
        <AntdButton
          icon={<FontAwesomeIcon icon={faXmark} />}
          type="text"
          onClick={() => setShowFilters(false)} 
          style={{
            position: 'absolute',
            top: -12,       
            right: -10,     
            zIndex: 10,     
            fontSize: 14,   
            color: '#999',  
            cursor: 'pointer',
          }}
        />
      </div>

      <Form
        form={filterForm}
        layout="vertical"
        style={{ marginLeft: "7px" }}
        onFinish={handleSearch}
      >
        <div className="row" style={{ padding: 5, marginLeft: "-12%", marginTop: "-5%", marginRight: "5%" }}>
          {[
            ["purchaseDateFrom", "From Date", <DatePickerField className="col-md-12" style={{ width: "120%" }} format="DD-MM-YYYY" />],
            ["purchaseDateTo", "To Date", <DatePickerField style={{ width: "120%" }} format="DD-MM-YYYY" />],
            ["description", "Description", <InputField style={{ width: "120%" }} placeholder="Enter description" />],
            ["assetTagId", "Asset Tag ID", <InputField style={{ width: "120%" }} placeholder="Enter Tag ID" />],
            ["brand", "Brand", <InputField style={{ width: "120%" }} placeholder="Enter Brand" />],
            ["model", "Model", <InputField style={{ width: "120%" }} placeholder="Enter Model" />],
            ["purchasedFrom", "Purchased From", <InputField style={{ width: "120%" }} placeholder="Enter Vendor" />],
            ["cost", "Cost", <InputField style={{ width: "120%" }} placeholder="Enter Cost (₹)" />],
            [
              "category",
              "Category",
              <SelectInput
                style={{ width: "120%" }}
                allowClear
                placeholder="Select Category"
                options={getOptionsByPath(NestedDatabucket, [ADD_ASSET, ASSET_CATEGORY])}
              />,
            ],
            [
              "department",
              "Department",
              <SelectInput
                style={{ width: "120%" }}
                allowClear
                placeholder="Select Department"
                options={getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE, EMPLOYEE_DEPARTMENT])}
              />,
            ],
            [
              "createdBy",
              "Created By",
              <SelectInput
                style={{ width: "120%" }}
                allowClear
                placeholder="Created By"
                options={getAssignToUsers(assignToUsers)}
              />,
            ],
          ].map(([name, label, input], index) => (
            <div key={index} className="col-md-12">
              <Form.Item
                name={name}
                label={label}
                className={
                  ["purchaseDateFrom", "purchaseDateTo", "category", "department"].includes(name)
                    ? "filter-form-item"
                    : "filter-form-item-secondary"
                }
              >
                {input}
              </Form.Item>
            </div>
          ))}
          <div
            style={{
              marginBottom: "10px",
              display: "flex",
              justifyContent: "space-between",
              marginTop: 10,
            }}
          >
            <div className="col-md-6 mb-2">
              <AntdButton type="primary" htmlType="submit" label={"Search"} />
            </div>
            <div className="col-md-6 mb-2">
              <AntdButton
                onClick={handleClear}
                style={{ backgroundColor: "#6c757d", color: "#fff", border: "none" }}
                label={"Clear"}
              />
            </div>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default ListAssetsFilters;
